export default async function ({ store, redirect, route, from }) {
    if (route = localStorage.getItem('apropos-jobs__redirect-to')) {
        localStorage.removeItem('apropos-jobs__redirect-to')
        return redirect(200, route)
    }
}